import Cookies from "js-cookie"

const AUTH_COOKIE_NAMES = ["refreshToken", "accessToken"] as const

export const clearAuthCookies = (hostname = window.location.hostname) => {
  AUTH_COOKIE_NAMES.forEach((cookieName) => {
    Cookies.remove(cookieName, { path: "/" })

    // Remote API responses share auth cookies across *.moogli.io. Removing
    // only a host-scoped cookie leaves the shared session cookie behind.
    if (hostname === "moogli.io" || hostname.endsWith(".moogli.io"))
      Cookies.remove(cookieName, {
        path: "/",
        domain: "moogli.io",
        secure: true,
        sameSite: "none",
      })
  })
}
